import { buildMonthlyProjection as sharedBuildMonthlyProjection } from './model/forecastDriverModel';

export const buildMonthlyProjection = sharedBuildMonthlyProjection;

export {
  BASE_CREDIT_LOSS_RATE,
  DEFAULT_MACRO_VARIABLES,
  FORECAST_YEARS,
  MACRO_SENSITIVITY_COEFFICIENTS,
  MONTH_LABELS,
  annualBalanceGrowthPercent,
  applyMonthlyGrowth,
  buildAnnualFromMonthly,
  combinedAnnualizedGrowthRate,
  deriveBridgeOpeningPortfolio,
  deriveLatestActualMonth,
  periodGrowthPercent,
  resolveMacroVariable,
  runDriverModel
} from './model/forecastDriverModel';
